﻿/**
* Get
* Get a value from a cookie
* @param {string} name - name of the cookie
* @returns {mixed}
*/
export function get (name) {
    let nameEQ = name + "=",
        ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
}

/**
 * Set
 * Set a cookie
 * @param {string} name - name of cookie
 * @param 
 */
export function set(name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = name + "=" + c_value;
}